/** Reload images on submit */
if (typeof CRM !== 'undefined') {
    CRM.$(document).on('crmFormSuccess', function() {
        const image = document.querySelector('.profile-image-upload img');
        if (image) {
            const src = new URL(image.getAttribute('src'));
            src.searchParams.append('date', new Date().getTime())
            image.setAttribute('src', src.toString());
        }
    });
}